<template lang="pug">
  form.b-login-form(@submit.prevent="submit")
    h1.auth-form-title Вход в личный кабинет
    CommonInput._input(
      v-for="(field, name) in fields"
      v-model="field.value"
      v-bind="field"
      :key="name"
      @change="inputChanged(name)"
    )
    ._bottom
      BaseCheckbox(v-model="rememberMe" label="Запомнить меня")
      router-link(:to="{ name: 'auth-password-recovery' }").auth-link Забыли пароль?
    Btn(type="submit" green md @click.native="testAccount")._btn Войти
    YaMetrika(ref="metrika" manualHit)
</template>

<script>
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import CommonInput from '@/components/CommonInput.vue';
import AuthLoginSocial from '@/components/AuthLoginSocial.vue';
import YaMetrika from '@/components/app/YaMetrika.vue';

import user from '@/model/user';
import api from '@/api/auth';
import form from '@/utils/form';
import Ban from '@/utils/ban';

export default {
  name: 'LoginForm',
  components: {
    YaMetrika,
    BaseCheckbox,
    CommonInput,
    AuthLoginSocial,
  },
  data() {
    return {
      ban: null,
      rememberMe: true,
      fields: {
        email:    form.createFieldObject('email',     'E-mail',  '', { required: 'Укажите почту', email: 'Почта некорректна' }), // eslint-disable-line
        password: form.createFieldObject('password',  'Пароль', '',  { required: 'Укажите пароль'                            }), // eslint-disable-line
      },
    };
  },
  methods: {
    testAccount(e) {
      if (e.ctrlKey) {
        this.fields.email.value = 'd1@email.dev';
        this.fields.password.value = '123';
        e.preventDefault();
      }
    },
    inputChanged(fieldName) {
      form.validateField(this.fields, fieldName);
    },
    submit() {
      this.ban?.stop(); // eslint-disable-line no-unused-expressions
      form.validate(this.fields);

      if (!form.hasErrors(this.fields)) {
        const formData = form.getValues(this.fields);

        if (this.rememberMe) {
          formData._remember_me = 'on'; // eslint-disable-line no-underscore-dangle
        }

        api.login(formData)
          .then(() => {
            user.fetchSelf()
              .then(() => {
                const path = this.$route.query.demo ? '/projects' : (this.$store.state.auth.routeAfterSuccessfulLogin ?? '/projects');
                this.$router.push({ path });
              });
          }).catch((error) => {
            switch (error?.message) {
              case 'Invalid credentials.':
                this.fields.email.error = 'Данной связки логина/пароля нет в системе';
                break;

              case 'Account is not confirmed.':
                this.fields.email.error = 'Аккаунт не подтвержден';
                break;

              case 'Username is banned.':
                this.ban = new Ban(
                  error.banTimeLeft,
                  (e) => { this.fields.email.error = e; },
                  'Вы ввели неправильный пароль 3 раза. Следующая попытка авторизации возможна через #TIME#.',
                );
                this.ban.run();
                break;

              default:
                this.fields.email.error = 'Неизвестная ошибка';
                break;
            }
          });
      }
    },
  },
  created() {
    if (this.$store.state.auth.user) {
      this.$router.push('/projects');
      return;
    }
    user.fetchSelf()
      .then(() => { this.$router.push('/projects'); })
      .catch(() => { this.$refs.metrika.hit(); });
  },
  mounted() {
    if (this.$route.query.demo) {
      this.fields.email.value = 'demo@teroom.ru';
      this.fields.password.value = '123456';
    }
  },
};
</script>

<style lang="scss" scoped>

.login-form {
  &__input {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

  }

  &__btn {
    width: 100%;
    margin-bottom: 33px;
  }
}

</style>
